import { z } from 'zod';

const filterModeSchema = z
  .enum(['include', 'inclusive', 'exclude', 'exclusive'])
  .transform((val): 'include' | 'exclude' =>
    val === 'inclusive' || val === 'include' ? 'include' : 'exclude'
  );

export const entityFilterSchema = z.object({
  mode: filterModeSchema,
  ids: z.array(z.string()).min(1),
});

export type EntityFilter = z.infer<typeof entityFilterSchema>;

export const ingestionFiltersSchema = z.object({
  standards: entityFilterSchema.optional(),
  chapters: entityFilterSchema.optional(),
  rules: entityFilterSchema.optional(),
});

export type IngestionFilters = z.infer<typeof ingestionFiltersSchema>;

export const ingestionConfigJsonSchema = z.object({
  filters: ingestionFiltersSchema.optional(),
});
